import { ApiResponse, RioApiDelete, RioApiGet, RioApiPost } from "rio.react.all";
import { UserApiModel } from "../apiModels/UserApiModel";
import { UserGroupApiModel } from "../apiModels/UserGroupApiModel";

export class UserApi {

    static getUsers() {
        return RioApiGet.asPromise<Array<UserApiModel>>("/api/user/get");
    }

    static getUser(userId: number) {
        return RioApiGet.asPromise<UserApiModel>("/api/user/getuser/" + userId);
    }

    static postUser(user: UserApiModel) {
        return RioApiPost.asPromise<UserApiModel>("/api/user/update", user);
    }

    static deleteUser(userId: number) {
        return RioApiPost.asPromise<UserApiModel>("/api/user/delete", userId);
    }

    static getAvailableGroups() {
        return RioApiGet.asPromise<Array<UserGroupApiModel>>("/api/user/availablegroups");
    }
}